package co.maytes.standupbot.dashboard.components.widgets

import androidx.compose.runtime.Composable
import co.maytes.standupbot.dashboard.components.widgets.svg.Svg
import co.maytes.standupbot.dashboard.components.widgets.svg.SvgPath
import co.maytes.standupbot.dashboard.styles.Motion

private const val CHECK_PATH = "M20 6 9 17l-5-5"
private const val CHECK_STROKE_WIDTH = "2.5"

@Composable
fun AnimatedCheck(sizePx: Int = 14, strokeColor: String = "currentColor") {
    Svg(attrs = {
        classes("sb-check-draw")
        attr("viewBox", "0 0 24 24")
        attr("width", sizePx.toString())
        attr("height", sizePx.toString())
        attr("fill", "none")
        attr("stroke", strokeColor)
        attr("stroke-width", CHECK_STROKE_WIDTH)
        attr("stroke-linecap", "round")
        attr("stroke-linejoin", "round")
        attr("aria-hidden", "true")
    }) {
        SvgPath(attrs = {
            attr("d", CHECK_PATH)
            attr("pathLength", Motion.CHECK_DASH_LENGTH.toString())
        })
    }
}
